import { EGeoFocusActionType, TMapActions } from '../../actions';

export const defaultState = false;

export function isAwaitingGeoFocusReducer(state: boolean = defaultState, action: TMapActions): boolean {
  switch (action.type) {
    case EGeoFocusActionType.SetAwaitingGeoFocus:
      return action.payload;
    default:
      return state;
  }
}
